export default "__VITE_ASSET__c39f22f0__"